export const TrailerIntent = {
  ALL: 'None',
  LIVE: 'Live',
  DROP: 'Drop',
};

export type TrailerIntent = (typeof TrailerIntent)[keyof typeof TrailerIntent];
